import React from "react";
import { BadgeCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const differentiators = [{
  title: "Skuteczność",
  description: "Usuwamy 100% osadów i kamienia, przywracając fabryczną drożność Twoich rur i grzejników."
}, {
  title: "Oszczędność",
  description: "Czysta instalacja CO to nawet o 25% niższe rachunki za ogrzewanie i dłuższa żywotność kotła."
}, {
  title: "Bezpieczeństwo",
  description: "Pracujemy na specjalistycznym sprzęcie i certyfikowanej chemii, która chroni uszczelnienia."
}, {
  title: "Standard Clean",
  description: "Zasada 'No Mess' – dbamy o czystość Twojego domu, stosując profesjonalne zabezpieczenia."
}, {
  title: "Lokalna Firma",
  description: "Jesteśmy z Pszczyny. Gwarantujemy szybki dojazd, terminowość i pełne wsparcie serwisowe."
}];
export default function FundamentySkutecznosci() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="3345" id="nasza-misja-i-standardy" ref={ref} className={cn("bg-background text-foreground py-20 px-8 border-t border-border/10", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-700 ease-out")}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-12">
          {differentiators.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-start space-y-4 group">
              <div className="p-3 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300 shadow-sm group-hover:shadow-lg group-hover:shadow-primary/20">
                <BadgeCheck className="w-8 h-8" strokeWidth={1.5} />
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-extrabold tracking-tighter text-secondary leading-tight">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground font-medium leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}